import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('../views/ForgotPasswordView.vue')
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('../views/ResetPasswordView.vue')
    },
    {
      path: '/',
      redirect: '/login' 
    },
    {
      path: '/admin',
      component: () => import('../views/AdminLayout.vue'),
      meta: { requiresAuth: true, role: 'admin' },
      children: [
        {
          path: 'users',
          name: 'admin-users',
          component: () => import('../views/admin/AdminUsers.vue'),
          meta: { title: 'Gestión de Usuarios' }
        },
        {
          path: 'tubes',
          name: 'admin-tubes',
          component: () => import('../views/admin/AdminTubes.vue'),
          meta: { title: 'Tipos de Tubos' }
        },
        {
          path: 'units',
          name: 'admin-units',
          component: () => import('../views/admin/AdminUnits.vue'),
          meta: { title: 'Stock de Tubos' }
        },
        {
          path: 'companies',
          name: 'admin-companies',
          component: () => import('../views/admin/AdminCompanies.vue'),
          meta: { title: 'Empresas' }
        },
        {
          path: 'deliveries',
          name: 'admin-deliveries',
          component: () => import('../views/admin/AdminDeliveries.vue'),
          meta: { title: 'Gestión de Entregas' }
        },
        {
          path: 'settings',
          name: 'admin-settings',
          component: () => import('../views/admin/AdminSettings.vue'),
          meta: { title: 'Configuración' }
        },
        {
          path: 'units/print',
          name: 'admin-units-print',
          component: () => import('../views/admin/AdminBulkPrint.vue'),
          meta: { title: 'Impresión Masiva' }
        },
        {
          path: 'bulk-load',
          name: 'admin-bulk-load',
          component: () => import('../views/admin/AdminBulkLoad.vue'),
          meta: { title: 'Carga Masiva de Stock' }
        },
        {
          path: 'owners',
          name: 'admin-owners',
          component: () => import('../views/admin/AdminOwners.vue'),
          meta: { title: 'Propietarios' }
        },
        {
          path: 'dispatch',
          name: 'admin-dispatch',
          component: () => import('../views/admin/AdminDispatch.vue'),
          meta: { title: 'Despacho de Depósito' }
        }
      ]
    },
    {
      path: '/dashboard',
      component: () => import('../views/UserLayout.vue'),
      meta: { requiresAuth: true, role: 'user' },
      children: [
        {
            path: '',
            name: 'user-home',
            component: () => import('../views/user/UserDeliveries.vue')
        },
        {
            path: 'delivery/:id',
            name: 'delivery-detail',
            component: () => import('../views/user/DeliveryDetail.vue')
        }
      ]
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const token = localStorage.getItem('token')
  
  // If we have a token but no user object in store, we might need a refresh 
  // but for now we trust the localStorage user if it exists
  const isAuthenticated = !!authStore.user || !!token

  // If already logged in and trying to go to login/forgot-password/reset-password
  if (isAuthenticated && (to.path === '/login' || to.path === '/forgot-password' || to.path === '/reset-password' || to.path === '/')) {
    if (authStore.user?.role === 'admin') return next('/admin/users')
    else if (authStore.user?.role === 'user') return next('/dashboard')
    else return next() // Fallback
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated) {
    next('/login')
  } else if (requiresAuth && to.meta.role && authStore.user?.role !== to.meta.role) {
    // Redirect if role doesn't match
    if (authStore.user?.role === 'admin') next('/admin/users')
    else if (authStore.user?.role === 'user') next('/dashboard')
    else next('/login')
  } else {
    next()
  }
})

router.onError((error, to) => {
  if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('Importing a module script failed')) {
    if (!to?.meta?.reload) {
        window.location = to.fullPath
    }
  }
})

export default router
